<template>
  <router-view />
</template>

<script>
export default {
    name: "Testing",
    components: {},
    data() {
        return {};
    },
};
</script>

<style lang="scss">
</style>

